module.exports = __webpack_public_path__ + "img/donaciones.1b8c2d7a.jpg";